import { Component, OnInit } from '@angular/core';
import { HttpService } from '../http.service';

@Component({
  selector: 'app-payment-failed',
  templateUrl: './payment-failed.component.html',
  styleUrls: ['./payment-failed.component.scss'],
})
export class PaymentFailedComponent implements OnInit {
  message: any;
  chegUrl: any;
  deviceType: string = '';
  constructor(private httpService: HttpService) {
    this.deviceType = this.httpService.getLocalStorage('DeviceType');
    this.chegUrl = this.httpService.getLocalStorage('ChegUrl');
    //  this.insertLogs(this.deviceType + ' this.deviceType');
    if (this.deviceType == 'web') {
      //   this.insertLogs(this.deviceType + ' 1this.deviceType == web');
      setTimeout(() => {
        window.open(this.chegUrl, '_self');
      }, 5000);
    }

    this.insertLogs(this.message);
    //  this.insertLogs(this.chegUrl + ' this.chegUrl');
  }

  ngOnInit(): void {}
  async insertLogs(url: any) {
    let data = {
      moduleName: 'payment-failed',
      url: url,
    };
    let result = this.httpService.insertLogs(data);
  }
}
